module.exports = __webpack_public_path__ + "img/Guinea.1e2c3aa8.svg";